import api from "./api";

export const invoiceService = {
  async getAll(params = {}) {
    try {
      const response = await api.get("/invoices", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/invoices/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async create(invoiceData) {
    try {
      const response = await api.post("/invoices", invoiceData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, invoiceData) {
    try {
      const response = await api.put(`/invoices/${id}`, invoiceData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await api.delete(`/invoices/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async generatePDF(invoiceId) {
    try {
      const response = await api.get(`/invoices/${invoiceId}/pdf`, {
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getInvoiceData(orderId) {
    try {
      const response = await api.get(`/invoices/${orderId}/data`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default invoiceService;
